import { render, staticRenderFns } from "./EditConta1.vue?vue&type=template&id=18203f7d&scoped=true"
import script from "./EditConta1.vue?vue&type=script&lang=js"
export * from "./EditConta1.vue?vue&type=script&lang=js"
import style0 from "./EditConta1.vue?vue&type=style&index=0&id=18203f7d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18203f7d",
  null
  
)

export default component.exports